import styles from "./Title.module.css";

type TitlePropsType = {
  title: string;
  className: string;
};

const Title = ({ title, className }: TitlePropsType) => {
  return <h2 className={`${styles.title} ${className}`}>{title}</h2>;
};

export default Title;
